/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Geben Sie mindestens {minimumLength} Zeichen oder Ziffern ein, um alle {sourceName}-Datensätze zu durchsuchen.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Keine Ergebnisse gefunden',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Prüfen Sie Ergebnisse aus anderen Quellen oder ändern Sie Ihr Schlüsselwort.',
  [HintsType.searching]: 'Suchen...',
  companyTabTitle: 'Unternehmen',
  personalTabTitle: 'Persönlich',
  direct: 'Direkt',
  extension: 'Durchw.',
  contact: 'Kontakt',
  mobile: 'Mobiltelefon',
  company: 'Unternehmen',
  home: 'Privat',
  home2: 'Privat',
  other: 'Sonstiges',
  business: 'Geschäftlich',
  business2: 'Geschäftlich',
  car: 'Auto',
  fax: 'Fax',
  assistant: 'Assistent',
  callback: 'Rückruf',
  MobileNumber: 'Mobiltelefonnummer',
  ContactNumber: 'Kontaktnummer',
  DirectNumber: 'Durchwahlnummer',
  doNotCall: 'Nicht anrufen',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
